import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from './components/Dashboard.vue';

Vue.use(Router);

export default new Router({
	routes: [
		{
            path: '/',
            redirect: "auth/login",
            component: () => import('@/AppPlantilla.vue'),
            children: [
                {
                    path: 'dashboard',
                    name: 'dashboard',
                    component: Dashboard
                },
                {
                    path: '/usuario',
                    name: 'usuario',
                    component: () => import('./pages/seguridad/Usuario.vue')
                },
                {
                    path: '/empresa',
                    name: 'empresa',
                    component: () => import('./pages/seguridad/Empresa.vue')
                },
                {
                    path: '/perfil',
                    name: 'perfil',
                    component: () => import('./pages/seguridad/Perfiles.vue')
                },
                {
                    path: '/permiso',
                    name: 'permiso',
                    component: () => import('./pages/seguridad/Permisos.vue')
                },
                {
                    path: '/cliente',
                    name: 'cliente',
                    component: () => import('./pages/administracion/Cliente.vue')
                },
                {
                    path: '/anio',
                    name: 'anio',
                    component: () => import('./pages/administracion/Anios.vue')
                },
                {
                    path: '/configuracion',
                    name: 'configuracion',
                    component: () => import('./pages/administracion/Configuracion.vue')
                },
                {
                    path: '/planilla',
                    name: 'planilla',
                    component: () => import('./pages/planilla/GenerarPlanilla.vue')
                },
                {
                    path: '/eliminarplanilla',
                    name: 'eliminarplanilla',
                    component: () => import('./pages/planilla/EliminarPlanilla.vue')
                },
                {
                    path: '/deudas',
                    name: 'deudas',
                    component: () => import('./pages/reportes/Deudas.vue')
                },
                {
                    path: '/tomalectura',
                    name: 'tomalectura',
                    component: () => import('./pages/reportes/TomaLecturas.vue')
                },
                {
                    path: '/consolidadoconsumo',
                    name: 'consolidadoconsumo',
                    component: () => import('./pages/reportes/ConsolidadoConsumo.vue')
                },
                {
                    path: '/recaudaciondiaria',
                    name: 'recaudaciondiaria',
                    component: () => import('./pages/reportes/RecaudacionDiaria.vue')
                },
                {
                    path: '/generarfactura',
                    name: 'generarfactura',
                    component: () => import('./pages/factura/GenerarFactura.vue')
                },
                {
                    path: '/eliminarfactura',
                    name: 'eliminarfactura',
                    component: () => import('./pages/factura/EliminarFactura.vue')
                },
                {
                    path: '/firmarfactura',
                    name: 'firmarfactura',
                    component: () => import('./pages/facturacionelectronica/Firmar.vue')
                },
                {
                    path: '/enviarfactura',
                    name: 'enviarfactura',
                    component: () => import('./pages/facturacionelectronica/Enviar.vue')
                },
                {
                    path: '/autorizarfactura',
                    name: 'autorizarfactura',
                    component: () => import('./pages/facturacionelectronica/Autorizar.vue')
                },
                {
                    path: '/historialUsuario',
                    name: 'historialUsuario',
                    component: () => import('./pages/reportes/HistorialUsuario.vue')
                },
                {
                    path: '/usuarioOrdenCorte',
                    name: 'usuarioOrdenCorte',
                    component: () => import('./pages/reportes/UsuarioOrdenCorte.vue')
                },
                {
                    path: '/usuarioAlDia',
                    name: 'usuarioAlDia',
                    component: () => import('./pages/reportes/UsuarioAlDia.vue')
                },
                {
                    path: '/nominaConsumidores',
                    name: 'nominaConsumidores',
                    component: () => import('./pages/reportes/NominaConsumidores.vue')
                },
            ]
        },
		{
            path: '/auth',
            component: () =>import('@/AppPlantillaBlank.vue'),
            children : [
                {
                    path: 'login',
                    name: 'login',
                    component: () => import('./pages/Login.vue')
                },
            ]
        },
	],
	scrollBehavior() {
		return {x: 0, y: 0};
	}
});
